import { IconButton } from '../../../actions/iconButton/IconButton'
import { RawRadioGroup } from '../../../forms/radioGroup/RawRadioGroup'
import { Dropdown } from '../../../structure/dropdown/Dropdown'
import type { ColumnFilterState } from '../useFilterState'

type State<T> = ColumnFilterState<T> & { type: 'radio' }

type Props<T> = {
  state: State<T>
  onStateChanged: (state: State<T>) => void
}

export const RadioFilter = <T,>({ state, onStateChanged }: Props<T>) => (
  <Dropdown
    element={
      <IconButton
        iconName="Filter"
        isSelected={state.selected !== state.options[0].label}
        className="-m-1"
      />
    }
    items={[
      {
        element: (
          <RawRadioGroup
            options={state.options.map(({ label }) => label)}
            renderFn={(label) => label}
            keyFn={(label) => label}
            value={state.selected}
            onChange={(selected) => onStateChanged({ ...state, selected })}
          />
        ),
      },
    ]}
  />
)
